export enum DeepfakeJobTypeEnum {
    IMAGE = 'image',
    VIDEO = 'video',
    AUDIO = 'audio',
    DOCUMENT_IMAGE = 'document_image',
}
